import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ROLES from "constants/roles";
import { BlockLink } from "../../components/Animations";
import PageTitle from "components/layout/PageTitle";
import debt from "../../assets/images/debt.png";
import ss from "../../assets/images/social_security.png";
import goals from "../../assets/images/goal.png";
import ModalVideo from "../../newComponents/ModuleVideos/ModalVideo";

class Planner extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}
  hasPermission(checkPermissions = []) {
    const availablePermissions =
      localStorage.getItem("permissionState") != "undefined" &&
      JSON.parse(localStorage.getItem("permissionState") || null);
    return checkPermissions.some(
      (p) => availablePermissions && availablePermissions.includes(p)
    );
  }

  render() {
    const block_links = [
      {
        href: "/debt-payoff",
        title: "Debt Payoff",
        visible: true,
        img: debt,
        permission: ["Fetch Payoff", "Super Admin"],
      },

      {
        href: "/planner/social-security",
        title: "Social Security",
        // visible: (this.props.user.role == ROLES.FREE_APP_SUITE) ? false : true,
        visible: true,
        img: ss,
        permission: ["Fetch Payoff", "Super Admin"],
      },

      {
        href: "/goals",
        title: "Goals",
        visible: true,
        img: goals,
        permission: ["Super Admin","FetchGoalsDetail"],
      },
    ];

    return (
      // <React.Fragment>
      //   <div className="page-nav-history">
      //     <div style={{ marginBottom: "5em" }}>
      //       <PageTitle title="Planner" />
      //     </div>
      //   </div>
      //   <div className="module-blocks">
      //     {block_links.map((blocklink, bindex) => {
      //       if (blocklink.visible) {
      //         return (
      //           <BlockLink
      //             key={bindex}
      //             img={blocklink.img}
      //             className="module-block-link"
      //             link={blocklink.href}
      //             title={blocklink.title}
      //           />
      //         );
      //       } else {
      //         return <React.Fragment></React.Fragment>;
      //       }
      //     })}
      //   </div>
      // </React.Fragment>
      <React.Fragment>
        <ModalVideo module="Planner" autoOpen={true} />
        <div className="page-nav-history">
          <div style={{ marginBottom: "5em" }}>
            <PageTitle title="Planner" />
          </div>
        </div>
        <div className="module-blocks">
          {block_links.map((blocklink, bindex) => {
            return (
              <div key={bindex} className="module-block-link">
                <Link
                  to={{
                    pathname: blocklink.href,
                    state: { title: blocklink.title },
                  }}
                  style={{
                    pointerEvents: this.hasPermission(blocklink.permission)
                      ? ""
                      : "none",
                  }}>
                  <div
                    className={"button-wrap-goals"}
                    style={{
                      cursor: this.hasPermission(blocklink.permission)
                        ? ""
                        : "not-allowed",
                      pointerEvents: this.hasPermission(blocklink.permission)
                        ? ""
                        : "none",
                      opacity: this.hasPermission(blocklink.permission)
                        ? "1"
                        : "0.5",
                    }}>
                    <div style={{ flexDirection: "column" }}>
                      <div className="col-12 mt-2 mb-2">
                        <img src={blocklink.img} className="img-btn" />
                      </div>
                      <div className="col-12 mb-2 mt-2">{blocklink.title}</div>
                    </div>
                  </div>
                </Link>
              </div>
            );
            {
              /* if (this.hasPermission(blocklink.permission)) {
              return (
                <BlockLink
                  key={bindex}
                  img={blocklink.img}
                  className="module-block-link"
                  style={{ opacity: "0.5" }}
                  link={blocklink.href}
                  title={blocklink.title}
                />
              );
            } else {
              return <React.Fragment></React.Fragment>;
            } */
            }
          })}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.rootReducer.loginUser.loginUserData,
  };
};
export default connect(mapStateToProps, null)(Planner);
